/**
 * @file CommandBase.js
 * @description Abstract base class for all terminal commands.
 */
export class CommandBase {
    constructor(kernel) {
        this.kernel = kernel;
        this.contentManager = kernel.get('content');
        this.fileSystem = null; // Will be injected by Terminal
        this.terminal = null;   // Will be injected by Terminal
    }

    /**
     * @param {string[]} args - Command arguments
     * @returns {Promise<void>}
     */
    async execute(args) {
        throw new Error('Command execute method not implemented.');
    }

    // Helper to write to terminal output
    write(text, className = '') {
        if (this.terminal) this.terminal.writeLine(text, className);
    }

    // Helper to write HTML
    writeHTML(html) {
        if (this.terminal) this.terminal.writeHTML(html);
    }
}